'use client';
'use strict';

var classes = {"root":"m-86a44da5","root--subtle":"m-220c80f2"};

module.exports = classes;
//# sourceMappingURL=CloseButton.module.css.cjs.map
